module.exports = __webpack_public_path__ + "static/img/bg.91750a9b.jpg";